import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";
import { AuthenticationService } from "../authentication/authentication.service";
import { CoreService } from "../core/core.service";

@Injectable({
  providedIn: "root"
})
export class QuestionBankService {
  private path = "/question-banks";
  private pathlang = "/languages";

  constructor(
    private backendService: BackendService,
    private auth: AuthenticationService,
    private core: CoreService
  ) { }

  getQuestionBankbyLangId(testid, langid) {
    return this.backendService.get(
      this.path + "/tests/" + testid + "/langs/" + langid
    );
  }

  getExams() {
    return this.backendService.get(this.path + "/exam");
  }

  getLanguages() {
    return this.backendService.get(this.pathlang);
  }

  getDashboard() {
    return this.backendService.get(this.path + "/question/dashboard");
  }

  getQuestionBank(testid) {
    return this.backendService.get(this.path + "/tests/" + testid);
  }

  saveQuestionBank(tests) {
    return this.backendService.post(this.path, tests);
  }

  getQuesBank() {
    return this.backendService.get(this.path + "/qb");
  }

  getQuesBankById(qbid) {
    return this.backendService.get(this.path + "/qb/" + qbid);
  }

  getQuesBankSummary(qbid) {
    return this.backendService.get(this.path + "/qb/" + qbid + "/summary");
  }

  getQuesBankErrors(qbid) {
    return this.backendService.get(this.path + "/qb/" + qbid + "/errors");
  }

  getQuestionBankByTestId(testid) {
    return this.backendService.get(this.path + "/test/" + testid);
  }
  getQuestions(qbid) {
    return this.backendService.get(this.path + "/qb/" + qbid + "/questions");
  }

  getQuestionById(qbid, qid) {
    return this.backendService.get(
      this.path + "/qb/" + qbid + "/questions/" + qid
    );
  }

  approveQuestionBank(qbid) {
    return this.backendService.post(this.path + "/qb/" + qbid + "/approve", {});
  }

  encryptQB(qbid, data) {
    //secret, zipapss
    return this.backendService.post(
      this.path + "/qb/" + qbid + "/encrypt",
      data
    );
  }

  deleteQuestionBank(qbid) {
    return this.backendService.post(this.path + "/qb/" + qbid + "/delete", {});
  }

  downloadEncryptedQB(qbid) {
    var url =
      this.core.getRootPath() +
      this.path +
      "/qb/" +
      qbid +
      "/download?token=" +
      this.auth.getAuthToken();
    url +=
      "&appname=" +
      this.core.getAppName() +
      "&usertype=" +
      this.core.getUserType();
    window.open(url, "_blank");
  }
}
